<template>
  <div class="login">
    <div class="left">
      <!-- <img src="../../assets/image/login_left.png" > -->
    </div>
    <div class="content">
      <form action="" method="post" :model="loginForm"  ref="loginForm" @submit.prevent="submit">
        <div class="title">欢迎登录</div>
        <div class="login_li account_li">
          <input type="text" placeholder="请输入账号" v-model="loginForm.account">
        </div>
        <div class="login_li password_li">
          <input type="password" placeholder="请输入密码" v-model="loginForm.password">
        </div>
        <div class="login_li">
          <button type="submit" >登录</button>
        </div>
      </form>
    </div>
    <p class="technical_support"> {{technicalSupport}}</p>
  </div>
</template>

<script>
import { technicalSupport} from '../../config'
export default {
  name: 'login',
  data(){
    return {
      technicalSupport,
      loginForm:{
        account:'',
        password:''
      }
    }
  },
  components: {
  },
  created(){
    localStorage.clear()
  },
  mounted(){
    
  },
  methods:{
    getConfig(){
      this.$api.user.getConfig()
        .then(res=>{
          if(res.code === 0){
            this.$store.commit('saveConfig',res.result)
          }else{
            this.$message.error(res.message);
          }
        }) 
    },
    getRouters(){
      this.$api.user.getRouters()
        .then(res=>{
          if(res.code === 0){
            let routerArr = res.result
            this.$store.commit('saveRouters',routerArr)
            
          }else{
            this.$message.error(res.message);
          }
        }) 
    },
    getProvince(){
      this.$api.user.getProvince()
        .then(res=>{
          if(res.code === 0){
            this.$store.commit('saveProvince',res.result)
          }else{
            this.$message.error(res.message);
          }
        }) 
    },
    submit() {
      if(this.loginForm.account == ''){
        this.$message.error('请输入用户名')
      }else if(this.loginForm.password == ''){
        this.$message.error('请输入密码');
      }else{
        var params = {
          username: this.loginForm.account,
          password: this.loginForm.password
        }
        let that = this
        this.$api.user.login(params)
          .then(res=>{
              if(res.code === 0){
                this.$store.commit('saveLoginInfo',res.result)
                localStorage.setItem('getTime',String(+new Date()))
                //获取配置
                this.getConfig()
                this.getProvince()
                // this.getRouters()
                that.$router.replace({
                  path:'/index'
                })
              }
          })   
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '../../assets/scss/login.scss';
</style>
